import React from 'react';
import Success from '../../../assets/svgs/success.svg';

const KybUpdateConfirmation = () => {
  return (
    <div className="mt-6 flex flex-col items-center justify-center gap-8 rounded-lg border border-[#F1F2F4] p-8 ">
      <div className="flex flex-col items-center justify-center gap-8">
        <img src={Success} alt="" className="w-[120px] h-[120px]" />
        <div className="flex flex-col items-center justify-center gap-3">
          <p className="text-[#1F2937] text-[32px] leading-10 font-bold ">
            {' '}
            KYB Submitted!{' '}
          </p>
          <p className="text-[#687588] text-lg font-normal">
            {' '}
            Your data has been successfully submitted for review{' '}
          </p>
        </div>
      </div>

      <div className="bg-[#F8F8F8] border-[#EEEFF2] w-full border p-8 rounded-3xl  flex flex-col gap-4">
        <div className='flex gap-7 items-center justify-center pb-6 border-b border-b-[#EEEFF2]'>
          <div>
            <p className='text-[#848A96] text-sm leading-[150%] tracking-[0.2px] '>Status</p>
            <p>Pending Review</p>
          </div>
          <div>
          <p className='text-[#848A96] text-sm leading-[150%] tracking-[0.2px] '>Estimated Review Time</p>
          <p>1-2 Business Days </p>
          </div>
        </div>

        <div className='grid gap-2'>
          <p className="ryno_text_semibold"> What happens next? </p>
          <ul className='list-disc list-inside'>
          <li className='text-[#687588] text-sm leading-[150%] tracking-[0.2px]'> Our compliance team will review your submitted documents</li>
          <li className='text-[#687588] text-sm leading-[150%] tracking-[0.2px]'> You&apos;ll receive an email notification with the review result</li>
          <li className='text-[#687588] text-sm leading-[150%] tracking-[0.2px]'> You can check the status of your request in the verification dashboard</li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default KybUpdateConfirmation;
